import React from "react";
// import Button from 'react-bootstrap/Button';
import { Modal } from 'react-bootstrap';
import '../../css/components/modal/modalCustom.css';
import * as M from "../../css/components/modal/modalPopup"
import { toast } from "wc-toast";

const ModalAppDownload = (props) => {
  const { mobile, dontShowAgain, setDontShowAgain, ...restProps } = props;
  return (
    // <Modal show={show} onHide={handleClose} centered animation>
    <Modal {...restProps} centered animation>
      <Modal.Header closeButton style={{ borderBottom: "none" }}></Modal.Header>
      <Modal.Body className="text-center px-2 pb-4 pt-0">
        <img src="/img/modal_toptopIcon.png" alt="" style={{ width: "110px", height: "110px" }} />
        <h1 className="app-modal-title">앱으로 만나보세요</h1>
        <p className="app-modal-subtitle">
          최적화 된 화면과 푸시알림으로<br />더 편리하게 이용해보실 수 있습니다
        </p>

        <div className="d-flex justify-content-between gap-2 mb-4">
          <M.AppDown_Btn
            // style={{ backgroundColor: "#335CA5" }}
            className="android-button"
            href="https://play.google.com/store/apps/details?id=kr.co.assembrix.toptop3"
            onClick={(e) => {
              if (mobile !== 'Android') {
                e.preventDefault();
                e.stopPropagation();
                toast.error("안드로이드 앱을 다운받을 수 없습니다.");
              }
            }}
          >
            안드로이드 다운받기
          </M.AppDown_Btn>
          <M.AppDown_Btn
            // style={{ backgroundColor: "#ED8B1E" }}         
            // className="w-50 d-flex align-items-center justify-content-center border-0 ios-button"
            className="ios-button"
            href="https://apps.apple.com/us/app/탑탑/id6743424762"
            onClick={(e) => {
              if (mobile !== 'Ios') {
                e.preventDefault();
                e.stopPropagation();
                toast.error("IOS 앱을 다운받을 수 없습니다.");
              }
            }}
          >
            IOS 다운받기
          </M.AppDown_Btn>
        </div>
        {/* <div className="d-flex align-items-center justify-content-center">
          <Form.Check
            type="checkbox"
            label="다시 보지 않기"
            style={{ transform: 'scale(1.4)' }}
            checked={dontShowAgain}
            onChange={() => setDontShowAgain(!dontShowAgain)}
          />
        </div> */}
        <div className="d-flex align-items-center justify-content-center">
          <label className="custom-checkbox-wrapper">
            <input
              type="checkbox"
              checked={dontShowAgain}
              onChange={() => setDontShowAgain(!dontShowAgain)}
              className="custom-checkbox-input"
            />
            <span className="custom-checkbox-label">다시 보지 않기</span>
          </label>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default ModalAppDownload;